import { Component, OnInit, Optional, Inject, Input } from '@angular/core';
import { IAppDataStore } from '@pershing/pershing-core';
import { TradingService, TradingEntitlements } from '@pershing/trading-common';

@Component({
    selector: 'exchange-agreement-confirm',
    templateUrl: './exchange-agreement-confirm.component.html'
})
export class ExchangeAgreementConfirmComponent implements OnInit {
    @Input() platform: string;
    @Input() public tradingEntitlements: TradingEntitlements = null;

    resonspeData: any;
    alreadyAgreed: any;
    deviceType: string = 'desktop';
    constructor(private tradingService: TradingService, private appDataStore: IAppDataStore,
                @Optional() @Inject('AppSettings') appSettings: any) {
        if (!!appSettings.deviceType) {
            this.deviceType = appSettings.deviceType;
        }
    }
    ngOnInit() {
        console.log('Exchange Agreement Overview', this.appDataStore.get('RESPONSE'));
        // TODO - find out how to get this already agreed data.
//        this.resonspeData = this.appDataStore.get('RESPONSE');
//        this.alreadyAgreed = this.resonspeData.alreadyAgreed;
    }
    gotoBack() {
        this.tradingService.setExchangeAgreementDialogState('exit');
    }

}
